import { TRPCClientError, TRPCLink } from '@trpc/client'
import { AnyRouter } from '@trpc/server'
import { observable } from '@trpc/server/observable'
import { ZodIssue as $ZodIssue } from 'zod'

export type FieldErrors = Record<string, $ZodIssue>

export type ValidationError = TRPCClientError<AnyRouter> & { fields: FieldErrors }

export function parseZodIssues(issues: $ZodIssue[]): FieldErrors {
  let fields: FieldErrors = {}
  for (let issue of issues) {
    let path = issue.path
      .map(bit => typeof bit === 'number' ? `[${bit}]` : String(bit))
      .join('.')
      .replace(/\.(\d+)/g, '[$1]')
    fields[path] = issue
  }
  return fields
}

export function zodErrorLink<T extends AnyRouter>(): TRPCLink<T> {
  return () => {
    return ({ op, next }) => {
      return observable((observer) => {
        let unsubscribe = next(op).subscribe({
          next: (result) => observer.next(result),
          error: (error) => {
            if (
              error instanceof TRPCClientError &&
              error.data?.code === 'BAD_REQUEST' &&
              error.data?.issues
            ) {
              (error as ValidationError).fields = parseZodIssues(error.data.issues)
            }
            observer.error(error)
          },
          complete: () => observer.complete(),
        })
        return unsubscribe
      })
    }
  }
}
